<template>
  <vs-popup class="preview_geo" :title="title" :active.sync="addNewDataLocal">
    <vs-card class="field-load-1 vs-con-loading__container">
      <vs-alert
        color="danger"
        :active="alertnya"
        icon-pack="feather"
        icon="icon-info">
        <span
          >While deletion process All paired Vehicle with this geofence will be
          Unpaired with it</span
        >
      </vs-alert>
      <vs-divider />

      <vs-row vs-w="12" style="max-height: calc(100vh - 320px); overflow: auto">
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-md="3"
          vs-sm="4"
          vs-xs="4"
          v-for="(list, index) in dataMobil"
          :key="index">
          <div class="p-2" style="height: 30px">
            <vs-chip color="primary">
              <vs-avatar icon-pack="feather" icon="icon-send" />
              <span>{{ list.license_plate }}</span>
            </vs-chip>
          </div>
        </vs-col>
      </vs-row>
      <!---->
      <!--<div style="display: inline-flex">-->
      <!---->
      <!--</div>-->
      <vs-divider />
      <vs-button
        v-if="alertnya"
        class="mt-3 mb-3 ml-2 shadow float-right mr-2 btn-load-1 vs-con-loading__container"
        type="gradient"
        color="danger"
        gradient-color-secondary="#CE9FFC"
        @click="deleteGeo()"
        >Confirm Delete
      </vs-button>
    </vs-card>
  </vs-popup>
</template>

<script>
import * as REPO from '../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    geoType: String,
    allData: Array,
    dataCoordinate: Array,
    alertData: Array,
    geoName: String,
    fleetGroupData: Array,
    deleteMode: Boolean,
    dataEdit: Object,
  },
  components: {},
  watch: {
    deleteMode(val) {
      if (val) {
        //
      } else {
        //
      }
    },
    s_alert(val) {
      this.calculateFleet(val)
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        if (this.addNewData) {
          this.dataMobil = []
          this.viewList(this.dataEdit._id)
        } else {
          this.dataCoor = []
        }
        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModalDelete')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      alert_array: [],
      fleet_array: [],
      s_alert: '',
      alertnya: false,
      dataCoor: [],
      dataMobil: [],
      fleetGroup: '',
    }
  },
  methods: {
    deleteGeo: function () {
      this.loadingBtnStart('btn-load-1')
      REPO.deletePOI(this.dataEdit._id).then((res) => {
        this.loadingBtnStart('btn-load-1')
        if (res.data.status == 'true') {
          this.$emit('deleteSuccess')
        }
      })
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    viewList(val) {
      this.loadingBtnStart('field-load-1')
      this.alertnya = false
      REPO.getListVehicleGeofence(val).then((res) => {
        this.loadingBtnStop('field-load-1')
        this.alertnya = true
        this.dataMobil = res.data.data
      })
    },
    clickEdit() {
      this.dataMobil = []
      this.$emit('closeModal')
    },
  },
}
</script>
<style>
.preview_geo > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
